import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

interface JobViewsChartProps {
  data: { id: string; title: string; views: number; company: string }[];
}

export function JobViewsChart({ data }: JobViewsChartProps) {
  const chartData = data.slice(0, 10).map(job => ({
    name: job.title.length > 20 ? job.title.substring(0, 20) + '...' : job.title,
    views: job.views
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Top 10 Vagas Mais Vistas</CardTitle>
        <CardDescription>Vagas com maior número de visualizações</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis 
              dataKey="name" 
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '6px'
              }}
            />
            <Bar 
              dataKey="views" 
              fill="hsl(var(--primary))"
              radius={[4, 4, 0, 0]}
              name="Visualizações"
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
